import { SKUS } from '@/constants';

export const skuData = [
  {
    sku: SKUS.TORSO,
    subtitle: 'Our quickest scan to search for cancer in the torso, not including the spine.',
    description:
      'Detection of solid tumors as small as 1.5cm in the organs of the chest, abdomen, and pelvis. This scan can isolate cancer from benign conditions such as cysts, hemangiomas, and abscesses. Head, spine, arms and legs are not included.',
  },
  {
    sku: SKUS.HEAD_AND_TORSO,
    subtitle:
      'A more detailed version of our Torso scan that includes a brain evaluation, not including the spine.',
    description:
      'Includes the high fidelity Torso scan to detect tumors as small as 1cm, including prostate, cervical, uterine, and ovarian cancers in the pelvis. The head and neck scan looks for cancers, brain aneurysms, small vessel ischemia (stroke risk factor), previous strokes, and sinus issues. Spine, arms, and legs are not included.',
  },
  {
    sku: SKUS.WHOLE_BODY,
    subtitle:
      'Our most comprehensive scan that assesses your anatomy, including major organs and spine.',
    description:
      'Combines the high fidelity Head & Torso scan with a detailed spine evaluation to detect disc herniation, spinal cord abnormalities, and spinal degeneration. Also scans for musculoskeletal conditions, fatty liver disease, and multiple sclerosis. Ankles may not be visible for people taller than 5’9” or 175cm. Arms and feet are not included.',
  },
  {
    sku: SKUS.WHOLE_BODY_ENHANCED_SCREENING,
    subtitle:
      'Our most advanced multi-modality screening. This protocol enhances (and includes) our comprehensive whole body scan that assesses the head, neck, chest, abdomen, pelvis, and legs for cancer, aneurysms and disease.',
    description: `Includes at-home blood draw to assess critical biomarkers of functional, metabolic, cardiovascular, liver, kidney, and hormonal health, a market-leading advanced brain health assessment (including brain volume analysis), and our proprietary FDA-cleared body composition analysis that evaluates volume and distribution of visceral, subcutaneous, and liver fat, volume and symmetry of lower body muscles, and organ size. Ankles may not be visible for people taller than 5’9” or 175cm. Arms and feet are not included.`,
  },
];
